var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"multi-banner-item",attrs:{"src":_vm._f("resizeThumbnail")(_vm.bannerInfo.thumbnail,{width:750, height: 420}),"alt":""}})}
var staticRenderFns = []

export { render, staticRenderFns }